import styled from 'styled-components';

export default styled.div`
  display: block;
`;

export const GalleryContainer = styled.div`
  margin: 15px 0;
  @media screen and (max-width: 768px) {
    margin: 10px 0;
  }
  @media screen and (max-width: 415px) {
    margin: 10px 0;
    .thumb:nth-of-type(even) {
      margin-right: 0;
    }
  }
  .thumbs-container {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: left;
    align-content: stretch;
    align-items: flex-start;
  }
  .thumb {
    order: 0;
    flex: 0 1 auto;
    align-self: auto;
    flex-basis: auto;
    flex-grow: 1;
    max-height: 200px;
    min-height: 100px;
    height: 12vw;
    min-width: 32.2% !important;
    max-width: 24.5%;
    margin: 5px;
    margin-bottom: 6px;
    border-radius: 4px;
    overflow: hidden;
    cursor: pointer;
    background-size: cover;
    background-position: center;
    display: inline-flex;
    position: relative;
    &:focus {
      outline: none;
    }
    &:last-child {
      margin-bottom: 0;
    }
    &:nth-of-type(3n) {
      margin-right: 0;
    }
    @media screen and (max-width: 991px) {
      max-width: 49%;
      &:nth-last-child(2) {
        margin-bottom: 0;
      }
      &:nth-of-type(3n) {
        margin-right: 5px;
      }
    }
    .icon {
      color: white;
      border: 2px solid white;
      padding: 4px 7px;
      border-radius: 23px;
      font-size: 24px;
      top: 22px !important;
      background: rgba(0, 0, 0, 0.13);
      height: 42px;
      width: 42px;
      position: relative;
      transform: translateY(-50%);
      margin: auto;
    }
    img {
      width: 100%;
    }
    .thumb-overlay {
      opacity: 0;
      transition: all 0.2s ease;
    }
    &:hover {
      transition: all 0.2s ease;
      box-shadow: 0 0px 5px 1px rgb(154, 154, 154);
      .thumb-overlay {
        background: #2c80ec;
        width: 100%;
        height: 100%;
        position: absolute;
        opacity: 0.3;
      }
    }
  }
`;

export const MagnifierContainer = styled.span`
  @media screen and (max-width: 700px) {
    > div:first-of-type {
      width: 100vw !important;
      height: auto;
    }
  }
`;

export const HeaderContainer = styled.div`
  border-bottom: 1px solid white;
  position: fixed;
  width: 100vw;
  z-index: 10;
  top: 0;
  left: 0;
  padding: 10px;
  padding-bottom: 12px;

  .delete-btn {
    background: white;
    border-radius: 2px;
    vertical-align: top;
    padding: 1px 11px;
    font-size: 13px;

    &:disabled {
      cursor: not-allowed;
      color: #d0d0d0;
    }
  }

  .close-btn {
    background: none;
    border: none;
    color: white;
    float: right;
    display: flex;
    cursor: pointer;
    &:focus {
      outline: 0;
    }

    svg {
      display: inline-block;
      width: 21px;
      height: 19px;
      margin-right: 7px;
      fill: white;
      position: relative;
      top: -2px;
    }
  }
`;

